import React from 'react';
import propTypes from 'prop-types';

import './PageSplit.scss';

const PageSplit = ({ children, header, leftClassName, rightClassName }) => {
  return (
    <div className="split-page">
      {header && <div className="split-header">{header()}</div>}
      <div className="flex-row">
        <div className={`page-left ${leftClassName}`}>{children[0]}</div>
        <div className={`page-right ${rightClassName}`}>{children[1]}</div>
      </div>
    </div>
  );
};

PageSplit.propTypes = {
  children: propTypes.node,
  header: propTypes.func,
  leftClassName: propTypes.string,
  rightClassName: propTypes.string,
};

PageSplit.defaultProps = {
  leftClassName: '',
  rightClassName: '',
};

export default PageSplit;
